import React from 'react';
import { Users as LucideUsers } from 'lucide-react';

interface UsersProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const Users: React.FC<UsersProps> = ({ width = 24, height = 24, className, style }) => (
  <LucideUsers width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default Users;
